<template>
  <main>
    <header-component v-if="access_type === 'web'" />
    <section
      :class="{
        'video web': access_type === 'web',
        'video app': access_type === 'app',
      }"
    >
      <div class="container">
        <div class="row clearfix">
          <div
            class="
              offset-xxl-2
              col-xxl-8
              offset-xl-2
              col-xl-8
              offset-lg-1
              col-lg-10
              offset-md-1
              col-md-10 col-12
            "
          >
            <theme-select-component
              v-if="data.screen_type === 'theme'"
              @childs-event="onChildEvent"
            />
            <video-upload-component
              v-else-if="data.screen_type === 'upload'"
              @childs-event="onChildEvent"
            />
            <video-effect-component
              v-else-if="data.screen_type === 'effect'"
              :step_type="data.step_type"
              :step_info="data.step_info"
              @childs-event="onChildEvent"
            />
            <video-upload-effect-component
              v-else-if="data.screen_type === 'upload-effect'"
              @childs-event="onChildEvent"
            />
            <video-image-component
              v-else-if="data.screen_type === 'image'"
              :step_type="data.step_type"
              :step_info="data.step_info"
              @childs-event="onChildEvent"
            />
            <video-picture-component
              v-else-if="data.screen_type === 'picture'"
              :step_type="data.step_type"
              :step_info="data.step_info"
              @childs-event="onChildEvent"
            />
            <video-encoding-component
              v-else-if="data.screen_type === 'encoding'"
              :step_type="data.step_type"
              :step_info="data.step_info"
              @childs-event="onChildEvent"
            />
            <select-video-type-component
              v-else
              :step_type="data.step_type"
              :step_info="data.step_info"
              @childs-event="onChildEvent"
            />
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { Common } from '@src/common';
import videoData from '@api/video';
import EventBus from '@utils/bus';
import headerComponent from '@components/Header.vue';
import selectVideoTypeComponent from '@components/video/select_video_type.vue';
import themeSelectComponent from '@components/video/theme_select.vue';
import videoUploadComponent from '@components/video/video_upload.vue';
import videoEffectComponent from '@components/video/video_effect.vue';
import videoUploadEffectComponent from '@components/video/video_upload_effect.vue';
import videoImageComponent from '@components/video/video_image.vue';
import videoPictureComponent from '@components/video/video_picture.vue';
import videoEncodingComponent from '@components/video/video_encoding.vue';

const data = {
  access_type: '',
  screen_type: '',
  step_type: '',
  step_info: {},
};

function childCallback(callback) {
  data.access_type = sessionStorage.getItem('access_type');

  if (callback.type === Common.EVT_CB_SCREEN_TYPE) {
    const { screen_type: screenType, data: stepInfo } = callback;
    data.screen_type = screenType;

    if (
      screenType === 'effect' ||
      screenType === 'image' ||
      screenType === 'picture'
    ) {
      data.step_type = stepInfo.step_type;
      data.step_info = stepInfo;
    } else if (screenType === 'encoding') {
      data.step_type = stepInfo.step_type;
      data.step_info = stepInfo.step_info;
    }
  }
}

export default {
  name: 'mov',
  head: {
    title: {
      inner: 'Video',
      separator: '|',
      complement: 'Smart Solution',
    },
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: 'Video Of Smart Solution',
      },
    ],
  },
  components: {
    headerComponent,
    selectVideoTypeComponent,
    themeSelectComponent,
    videoUploadComponent,
    videoEffectComponent,
    videoUploadEffectComponent,
    videoImageComponent,
    videoPictureComponent,
    videoEncodingComponent,
  },
  data() {
    return {
      data,
      access_type: '',
      q: {
        screen_type: this.$route.query.screen_type,
      },
    };
  },
  created() {
    if (
      !videoData.data.product_type_id &&
      sessionStorage.getItem('access_type') === 'web'
    ) {
      window.location.href = '/';
    }

    if (sessionStorage.getItem('access_type')) {
      this.access_type = sessionStorage.getItem('access_type');
    } else {
      // WebView URL
      this.access_type = this.$route.query.access_type;
    }

    const isDefaultScreen = videoData.data.is_view_control;

    if (isDefaultScreen) {
      data.screen_type = '';
    }

    if (this.q.screen_type === 'theme') {
      data.screen_type = 'theme';
    }

    this.receiveEventInit(isDefaultScreen);
  },
  destroyed() {
    data.screen_type = '';
  },
  methods: {
    onChildEvent: childCallback,
    receiveEventInit(isDefaultScreen) {
      if (!isDefaultScreen) {
        EventBus.$on('childs-event', (value) => {
          childCallback(value);
        });
      }

      EventBus.$on('move-back', (type) => {
        data.screen_type = type;
      });
    },
  },
};
</script>

<style scoped lang="scss">
header + .video {
  &.web {
    padding-top: 98px;
    padding-bottom: 72px;
  }
}

.video {
  background-color: $gray-f1;
  min-height: 100vh;

  &.web {
    padding-top: 24px;
    padding-bottom: 18px;

    .card {
      padding: 24px;
    }
  }

  &.app {
    padding-top: 20px;

    .card {
      padding: 12px;
      min-height: 95vh;
    }
  }
}
</style>
